import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { libraryCollection, libraryBestsellers } from '@/mocks/neurobaby';

export default function LibrarySection() {
  const { t, i18n } = useTranslation();

  // Checkout de Hotmart de la Obra Completa segun el idioma de la pagina
  const obraCompletaCheckoutUrl =
    i18n.language === 'en'
      ? 'https://pay.hotmart.com/J107376645M'
      : 'https://pay.hotmart.com/H107376600L';

  // Checkout de Hotmart del pack de los 4 Best Sellers (Coleccion Sentires) segun el idioma de la pagina
  const sentiresPackCheckoutUrl =
    i18n.language === 'en'
      ? 'https://pay.hotmart.com/J107377305V'
      : 'https://pay.hotmart.com/P107377285E';

  const getBookImage = (book: typeof libraryBestsellers[0]) => {
    return i18n.language === 'en' && book.imageEn ? book.imageEn : book.image;
  };

  const packImage = i18n.language === 'en'
    ? 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/f6906bf2-25dd-4ab2-bb9b-e4df0e9a6939_compressed_ChatGPT-Image-10-ago-2026-01_12_19-a.m.-2.webp'
    : 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/f03ac408-7068-43f1-9d57-1aeb656c1691_compressed_ChatGPT-Image-10-ago-2026-01_11_26-a.m.-3.webp';

  const obraCompletaImage = i18n.language === 'en'
    ? 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/2c4c0c00-0eaf-4ce3-a46c-f941e5d7ec2e_compressed_ChatGPT-Image-12-ago-2026-03_15_52-p.m..webp'
    : 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/286d0fce-d92a-487d-ad9f-d15ccffea684_compressed_ChatGPT-Image-11-ago-2026-10_23_31-p.m.-2.webp';

  const tomoIndividualImage = i18n.language === 'en'
    ? 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/909913e3-874d-4b4e-aa07-d9658c681541_compressed_ChatGPT-Image-12-ago-2026-03_15_58-p.m..webp'
    : 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/44c79b66-13c2-4114-9e7f-ff17512684b0_compressed_ChatGPT-Image-11-ago-2026-10_22_09-p.m..webp';

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
            {t('home.library.subtitle')}
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-6">
            {t('home.library.title')}
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] max-w-3xl mx-auto leading-relaxed">
            {t('home.library.desc')}
          </p>
        </div>

        <div className="mb-16 md:mb-20">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block font-sans text-xs font-semibold text-[#5C4A3A] uppercase tracking-[0.2em] mb-3">
              {t('home.library.coleccion')}
            </span>
            <h3 className="font-serif text-2xl md:text-4xl font-bold text-[#8B6F5C] leading-tight mb-3">
              {t('home.library.coleccion_title')}
            </h3>
            <p className="font-sans text-sm text-[#3D2B1F] max-w-2xl mx-auto">
              {t('home.library.coleccion_desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-10 md:mb-12">
            <div className="bg-white rounded-2xl overflow-hidden border border-[#DCCDBF] flex flex-col sm:flex-row">
              <div className="w-full h-auto sm:max-h-none sm:w-[120px] md:w-[135px] flex-shrink-0 overflow-hidden">
                <img
                  src={obraCompletaImage}
                  alt={t('home.library.obra_completa')}
                  className="w-full h-auto object-contain sm:h-full sm:object-cover"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col sm:flex-row items-center gap-3 flex-1 min-w-0 text-center sm:text-left">
                <div className="flex-1 min-w-0 w-full">
                  <h4 className="font-serif text-base md:text-lg font-bold text-[#8B6F5C] mb-0.5">
                    {t('home.library.obra_completa')}
                  </h4>
                  <div className="flex items-center justify-center sm:justify-start gap-2.5 mb-0.5">
                    <span className="font-sans text-sm text-[#5C4A3A] line-through">$99.90</span>
                    <span className="font-serif text-xl md:text-2xl font-bold text-terracotta">$79</span>
                    <span className="font-sans text-xs text-[#5C4A3A]">{t('common.usd')}</span>
                  </div>
                  <p className="font-sans text-[11px] text-terracotta font-semibold">
                    {t('common.oferta_tiempo_limitado')}
                  </p>
                </div>
                <a
                  href={obraCompletaCheckoutUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center self-center sm:self-auto bg-[#AAB7A3] text-white px-4 py-2 rounded-full font-sans text-xs font-semibold hover:bg-[#8B6F5C] transition-colors duration-300 whitespace-nowrap flex-shrink-0 cursor-pointer"
                >
                  {t('common.comprar_coleccion')}
                </a>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden border border-[#DCCDBF] flex flex-col sm:flex-row">
              <div className="w-full h-auto sm:max-h-none sm:w-[120px] md:w-[135px] flex-shrink-0 overflow-hidden">
                <img
                  src={tomoIndividualImage}
                  alt={t('home.library.tomo_individual')}
                  className="w-full h-auto object-contain sm:h-full sm:object-cover"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col sm:flex-row items-center gap-3 flex-1 min-w-0 text-center sm:text-left">
                <div className="flex-1 min-w-0 w-full">
                  <h4 className="font-serif text-base md:text-lg font-bold text-[#8B6F5C] mb-0.5">
                    {t('home.library.tomo_individual')}
                  </h4>
                  <div className="flex items-center justify-center sm:justify-start gap-2 mb-0.5">
                    <span className="font-serif text-xl md:text-2xl font-bold text-terracotta">$9.99</span>
                    <span className="font-sans text-xs text-[#5C4A3A]">{t('common.usd')}</span>
                  </div>
                  <p className="font-sans text-[11px] text-[#5C4A3A]">
                    {t('home.library.elegi_capitulo')}
                  </p>
                </div>
                <Link
                  to="/capitulos-dormir-tranquila"
                  className="inline-flex items-center justify-center self-center sm:self-auto bg-[#AAB7A3] text-white px-4 py-2 rounded-full font-sans text-xs font-semibold hover:bg-[#8B6F5C] transition-colors duration-300 whitespace-nowrap flex-shrink-0"
                >
                  {t('common.ver_tomos')}
                </Link>
              </div>
            </div>
          </div>

          <div className="rounded-2xl border border-[#DCCDBF] overflow-hidden bg-[#EDE3DA]">
            <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-[#DCCDBF]">
              {/* Columna izquierda: capítulos 1-5 */}
              <div className="p-2 flex flex-col gap-1.5 md:gap-[5px] md:grid md:grid-cols-[max-content_1fr]">
                {libraryCollection.slice(0, 5).map((item) => (
                  <Fragment key={item.id}>
                    <div className="flex items-baseline md:items-center pl-4 pr-4 md:pr-2 pt-3 pb-1 md:py-2.5 bg-white rounded-t-xl md:rounded-l-xl md:rounded-tr-none">
                      <span className="font-serif text-2xl font-bold text-terracotta leading-none flex-shrink-0">{item.id}.</span>
                      <span className="font-sans text-sm font-extrabold text-[#5C3D2E] ml-1.5 break-words md:whitespace-nowrap">{t(`library.collection.${item.id}.title`, item.title)}</span>
                      <span className="text-[#C4A98A] mx-1 flex-shrink-0 hidden md:inline">—</span>
                    </div>
                    <div className="flex items-center pl-4 pr-4 md:pl-0 md:pr-4 pt-1 pb-3 md:py-2.5 bg-white rounded-b-xl md:rounded-r-xl md:rounded-bl-none">
                      <span className="font-sans text-xs text-[#3D2B1F]">{t(`library.collection.${item.id}.description`, item.description)}</span>
                    </div>
                  </Fragment>
                ))}
              </div>
              {/* Columna derecha: capítulos 6-10 */}
              <div className="p-2 flex flex-col gap-1.5 md:gap-[5px] md:grid md:grid-cols-[max-content_1fr]">
                {libraryCollection.slice(5, 10).map((item) => (
                  <Fragment key={item.id}>
                    <div className="flex items-baseline md:items-center pl-4 pr-4 md:pr-2 pt-3 pb-1 md:py-2.5 bg-white rounded-t-xl md:rounded-l-xl md:rounded-tr-none">
                      <span className="font-serif text-2xl font-bold text-terracotta leading-none flex-shrink-0">{item.id}.</span>
                      <span className="font-sans text-sm font-extrabold text-[#5C3D2E] ml-1.5 break-words md:whitespace-nowrap">{t(`library.collection.${item.id}.title`, item.title)}</span>
                      <span className="text-[#C4A98A] mx-1 flex-shrink-0 hidden md:inline">—</span>
                    </div>
                    <div className="flex items-center pl-4 pr-4 md:pl-0 md:pr-4 pt-1 pb-3 md:py-2.5 bg-white rounded-b-xl md:rounded-r-xl md:rounded-bl-none">
                      <span className="font-sans text-xs text-[#3D2B1F]">{t(`library.collection.${item.id}.description`, item.description)}</span>
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4 mb-16 md:mb-20">
          <div className="h-px bg-[#DCCDBF] flex-1" />
          <div className="w-3 h-3 rounded-full bg-terracotta/40" />
          <div className="h-px bg-[#DCCDBF] flex-1" />
        </div>

        <div>
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block font-sans text-xs font-semibold text-[#5C4A3A] uppercase tracking-[0.2em] mb-3">
              {t('home.library.best_sellers')}
            </span>
            <h3 className="font-serif text-2xl md:text-4xl font-bold text-[#8B6F5C] leading-tight mb-3">
              {t('home.library.best_sellers_title')}
            </h3>
            <p className="font-sans text-sm text-[#3D2B1F] max-w-2xl mx-auto">
              {t('home.library.best_sellers_desc')}
            </p>
          </div>

          <div className="bg-white rounded-2xl overflow-hidden border border-sand/40 mb-8 flex flex-col sm:flex-row">
            <div className="w-full h-auto sm:w-[170px] sm:h-[170px] flex-shrink-0 overflow-hidden">
              <img
                src={packImage}
                alt={i18n.language === 'en' ? 'Sentires Collection — The 4 Best Sellers' : 'Colección Sentires — Los 4 Best Sellers'}
                className="w-full h-auto object-contain sm:h-full sm:object-cover"
              />
            </div>
            <div className="p-4 flex flex-col sm:flex-row flex-grow items-center gap-3 sm:gap-4 text-center sm:text-left">
              <div className="flex-1 min-w-0 w-full">
                <span className="inline-block font-sans text-[11px] font-semibold text-terracotta uppercase tracking-[0.2em] mb-1">
                  {t('common.oferta_especial')}
                </span>
                <h3 className="font-serif text-lg font-bold text-[#8B6F5C] mb-1 leading-tight">
                  {t('home.library.pack_title')}
                </h3>
                <p className="font-sans text-sm text-[#3D2B1F] mb-1 leading-snug">
                  {t('home.library.pack_desc')}
                </p>
                <p className="font-sans text-xs text-[#5C4A3A]">
                  {t('common.oferta_tiempo_limitado')} · $49.90 {t('common.usd')}
                </p>
              </div>
              <a
                href={sentiresPackCheckoutUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center self-center sm:self-auto bg-terracotta text-white px-5 py-2.5 rounded-full font-sans text-sm font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap flex-shrink-0 cursor-pointer"
              >
                {t('common.comprar_coleccion')}
                <i className="ri-arrow-right-line ml-2" />
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6 mb-8">
            {libraryBestsellers.map((book) => (
              <div
                key={book.id}
                className="bg-white rounded-2xl overflow-hidden border border-[#DCCDBF] transition-all duration-300 hover:border-terracotta/30 flex flex-col sm:flex-row"
              >
                <div className="w-full h-auto max-h-[170px] sm:max-h-none sm:w-[100px] md:w-[112px] flex-shrink-0 overflow-hidden">
                  <img
                    src={getBookImage(book)}
                    alt={t(`library.bestsellers.${book.id}.title`, book.title)}
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="p-2 md:p-3 flex flex-col flex-grow justify-start">
                  <h4 className="font-serif text-base md:text-lg font-bold text-[#8B6F5C] leading-snug mb-0.5">
                    {t(`library.bestsellers.${book.id}.title`, book.title)}
                  </h4>
                  <p className="font-sans text-xs text-terracotta font-semibold mb-0.5">
                    {t(`library.bestsellers.${book.id}.subtitle`, book.subtitle)}
                  </p>
                  <p className="font-sans text-xs text-[#3D2B1F] leading-relaxed mb-1">
                    {t(`library.bestsellers.${book.id}.description`, book.description)}
                  </p>
                  <div className="flex items-center justify-between gap-2 mt-1">
                    <span className="font-sans text-lg font-bold text-[#8B6F5C] whitespace-nowrap">${book.price}</span>
                    <div className="flex items-center gap-1.5 flex-wrap">
                      <Link
                        to={book.route}
                        className="inline-flex items-center bg-terracotta text-white px-4 py-2 rounded-full font-sans text-xs font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap"
                      >
                        {t('common.conocer_mas')}
                      </Link>
                      <a
                        href="#"
                        rel="noopener noreferrer"
                        className="inline-flex items-center bg-white border border-[#AAB7A3]/30 text-[#AAB7A3] px-3 py-1.5 rounded-full font-sans text-xs font-semibold hover:bg-[#AAB7A3]/10 transition-colors duration-300 whitespace-nowrap"
                      >
                        <i className="ri-amazon-fill mr-1" />
                        {t('common.amazon_kindle')}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>


        </div>
      </div>
    </section>
  );
}